import { Checkbox, FormControl, FormControlLabel, InputLabel, makeStyles, MenuItem, Paper, Select, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import data from '../../json/tabelle.json';
import { DefaultInputProps, IRAP_PercDataClass } from '../../types/types';
import { API_elaboraIForfetari } from '../../utils/functions';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1)

//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         },
//         select: {
//             width: "10rem",
//             border: '1px solid black'
//         },
//     }),
// );

export default function RegimeNormale(props: DefaultInputProps) {
    const [global] = useGlobal<IGlobalState>();
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeRegimeNormale";
    const { state } = props;

    let showCassaProf: boolean = state.gestionePrevidenziale.cassaProfessionale;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraIForfetari(props, global, name, value, action, true);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    };

    const handleBlur = (e: any) => {
        // API_elaboraIForfetari(props, global);
    }

    const IRAP = data.IRAP as IRAP_PercDataClass;

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionTitle text="Regime normale"></SectionTitle>
            <SectionSubTitle text="Determinazione del reddito"></SectionSubTitle>
            <NumberField
                name="determinazioneDelReddito_G81"
                label={state.regimeNormale.determinazioneDelReddito_B81}
                value={state.regimeNormale.determinazioneDelReddito_G81}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G82"
                label={state.regimeNormale.determinazioneDelReddito_B82}
                value={state.regimeNormale.determinazioneDelReddito_G82}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G83"
                label={state.regimeNormale.determinazioneDelReddito_B83}
                value={state.regimeNormale.determinazioneDelReddito_G83}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="determinazioneDelReddito_G84"
                label={state.regimeNormale.determinazioneDelReddito_B84}
                value={state.regimeNormale.determinazioneDelReddito_G84}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G85"
                label={state.regimeNormale.determinazioneDelReddito_B85}
                value={state.regimeNormale.determinazioneDelReddito_G85}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G86"
                label={state.regimeNormale.determinazioneDelReddito_B86}
                value={state.regimeNormale.determinazioneDelReddito_G86}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G87"
                label={state.regimeNormale.determinazioneDelReddito_B87}
                value={state.regimeNormale.determinazioneDelReddito_G87}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G88"
                label={state.regimeNormale.determinazioneDelReddito_B88}
                value={state.regimeNormale.determinazioneDelReddito_G88}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G89"
                label={state.regimeNormale.determinazioneDelReddito_B89}
                value={state.regimeNormale.determinazioneDelReddito_G89}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
            />
            <NumberField
                name="determinazioneDelReddito_G90"
                label={state.regimeNormale.determinazioneDelReddito_B90}
                value={state.regimeNormale.determinazioneDelReddito_G90}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                name="determinazioneDelReddito_G91"
                label={state.regimeNormale.determinazioneDelReddito_B91}
                value={state.regimeNormale.determinazioneDelReddito_G91}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                hide={!state.famigliare}
                name="determinazioneDelReddito_G92"
                label={state.regimeNormale.determinazioneDelReddito_B92}
                value={state.regimeNormale.determinazioneDelReddito_G92}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                hide={!state.famigliare}
                name="determinazioneDelReddito_G93"
                label={state.regimeNormale.determinazioneDelReddito_B93}
                value={state.regimeNormale.determinazioneDelReddito_G93}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                hide={!(state.gestionePrevidenziale.aliquotaSep > 0)}
                name="determinazioneDelValoreDellaProduzioneNetta_L91"
                label="Contributi gestione separata"
                value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_L91}
                className={gClasses.textFieldReadOnly}
                readOnly={true}
            />
            <NumberField
                hide={!showCassaProf}
                name="determinazioneDelValoreDellaProduzioneNetta_L92"
                label="Contributi cassa professionale"
                value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_L92}
                onChange={handleChange} onBlur={handleBlur}
                className={gClasses.textField}
                tooltip="Da inserire manualmente"
            />
            {/* <SectionTitle text="Irap"></SectionTitle>
            <SectionSubTitle text="Determinazione del valore della produzione netta"></SectionSubTitle>
            <FormControlLabel className={gClasses.bottomControlLabel}
                labelPlacement="end"
                control={
                    <Checkbox
                        checked={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N81}
                        onChange={handleChangeChecked}
                        name='determinazioneDelValoreDellaProduzioneNetta_N81'
                        id='determinazioneDelValoreDellaProduzioneNetta_N81'
                        value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N81}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                }
                label="Assenza di autonoma organizzazione"
            /> */}
            {/* <div>
                <NumberField
                    name="determinazioneDelValoreDellaProduzioneNetta_N82"
                    label={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I82}
                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N82}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="determinazioneDelValoreDellaProduzioneNetta_N83"
                    label={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I83}
                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N83}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="determinazioneDelValoreDellaProduzioneNetta_N84"
                    label={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I84}
                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N84}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="determinazioneDelValoreDellaProduzioneNetta_N85"
                    label={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I85}
                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N85}
                    className={gClasses.textField}
                    onChange={handleChange} onBlur={handleBlur}
                    // readOnly={true}
                />
                <NumberField
                    name="determinazioneDelValoreDellaProduzioneNetta_N86"
                    label={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I86}
                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N86}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <FormControl className={gClasses.formControl}>
                    <InputLabel htmlFor="determinazioneDelValoreDellaProduzioneNetta_I88">{state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I88}</InputLabel>
                    <Select
                        className={gClasses.selectIForf}
                        value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_L88}
                        onChange={handleChangeSelect}
                        inputProps={{ name: 'determinazioneDelValoreDellaProduzioneNetta_L88', id: 'determinazioneDelValoreDellaProduzioneNetta_L88' }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={IRAP.perc_1}>{IRAP.perc_1}</MenuItem>
                        <MenuItem value={IRAP.perc_2}>{IRAP.perc_2}</MenuItem>
                        <MenuItem value={IRAP.perc_3}>{IRAP.perc_3}</MenuItem>
                        <MenuItem value={IRAP.perc_4}>{IRAP.perc_4}</MenuItem>
                        <MenuItem value={IRAP.perc_5}>{IRAP.perc_5}</MenuItem>
                    </Select>
                </FormControl>
                <NumberField
                    name="determinazioneDelValoreDellaProduzioneNetta_N89"
                    label={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_I89}
                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N89}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
            </div> */}
        </Paper>
    );
}